
seedWebApp.controller('EditItemCtrl', ['$scope', 'cols', 'item', '$uibModalInstance', function ($scope, cols, item, $uibModalInstance) {

        $scope.cols = cols;
        $scope.item = item;

        $scope.ok = function () {
            $uibModalInstance.close($scope.item);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


}]);
